import React, { Component } from "react";

import brand1 from "../assets/images/brand/brand-01.png";
import brand2 from "../assets/images/brand/brand-02.png";
import brand3 from "../assets/images/brand/brand-03.png";
import brand4 from "../assets/images/brand/brand-04.png";
import brand5 from "../assets/images/brand/brand-05.png";
import brand6 from "../assets/images/brand/brand-06.png";
import brand7 from "../assets/images/brand/brand-07.png";
// import brand8 from "../assets/images/brand/brand-08.png";
// import brand9 from "../assets/images/brand/brand-09.png";
import brand10 from "../assets/images/brand/brand-10.png";
// import brand11 from "../assets/images/brand/brand-11.png";
// import brand12 from "../assets/images/brand/brand-12.png";
import brand13 from "../assets/images/brand/brand-13.png";
import brand14 from "../assets/images/brand/brand-14.png";
import brand15 from "../assets/images/brand/brand-15.png";
import brand16 from "../assets/images/brand/brand-16.png";
// import brand17 from "../assets/images/brand/brand-17.png";
import brand18 from "../assets/images/brand/brand-18.png";
import brand19 from "../assets/images/brand/brand-19.png";
import brand20 from "../assets/images/brand/brand-20.png";
import brand21 from "../assets/images/brand/brand-21.png";

class BrandTwo extends Component {
  render() {
    return (
      <React.Fragment>
        <ul className="brand-style-2">
          <div style={{width: "100%", textAlign:"center", fontSize: "36px",
        lineHeight: "64px"}}>
             <h1>Marcas Asesoradas</h1>
          </div>
          <li>
            <img src={brand1} alt="Logo Images" />
          </li>
          <li>
            <img src={brand2} alt="Logo Images" />
          </li>
          <li>
            <img src={brand3} alt="Logo Images" />
          </li>
          <li>
            <img src={brand4} alt="Logo Images" />
          </li>
          <li>
            <img src={brand5} alt="Logo Images" />
          </li>
          <li>
            <img src={brand6} alt="Logo Images" />
          </li>
          <li>
            <img src={brand7} alt="Logo Images" />
          </li>
          {/* <li>
            <img src={brand8} alt="Logo Images" />
          </li> */}
          {/* <li>
            <img src={brand9} alt="Logo Images" />
          </li> */}
          <li>
            <img src={brand10} alt="Logo Images" />
          </li>
          {/* <li>
            <img src={brand11} alt="Logo Images" />
          </li>
          <li>
            <img src={brand12} alt="Logo Images" />
          </li> */}
          <li>
            <img src={brand13} alt="Logo Images" />
          </li>
          <li>
            <img src={brand14} alt="Logo Images" />
          </li>
          <li>
            <img src={brand15} alt="Logo Images" />
          </li>
          <li>
            <img src={brand16} alt="Logo Images" />
          </li>
          {/* <li>
            <img src={brand17} alt="Logo Images" />
          </li> */}
          <li>
            <img src={brand18} alt="Logo Images" />
          </li>
          <li>
            <img src={brand19} alt="Logo Images" />
          </li>
          <li>
            <img src={brand20} alt="Logo Images" />
          </li>
          <li>
            <img src={brand21} alt="Logo Images" />
          </li>
        </ul>
      </React.Fragment>
    );
  }
}

export default BrandTwo;
